import { render, staticRenderFns } from "./DeviceOverviewSliderCard.vue?vue&type=template&id=0cf669fc"
import script from "./DeviceOverviewSliderCard.vue?vue&type=script&lang=js"
export * from "./DeviceOverviewSliderCard.vue?vue&type=script&lang=js"
import style0 from "./DeviceOverviewSliderCard.vue?vue&type=style&index=0&id=0cf669fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports